import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

/**
 * @deprecated Do not add new instances of this component. Use 'ag1-pill' instead.
 */
@Component({
  selector: 'ag-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PillComponent {
  @Input()
  value: any;
  @Input()
  label: string;
  @Input()
  canRemove: boolean;
  @Output()
  remove = new EventEmitter<any>();

  constructor() {}

  handleRemoveClicked() {
    this.remove.emit(this.value);
  }
}
